// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, IconButton, Modal, Button } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import { getContactUs, sendReply } from "../../features/contactUs";
import { MdOutlineReplay } from "react-icons/md";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import SoftInput from "../../components/common/softInput";
import { toast } from "react-toastify";

const ContactUs = () => {
  const dispatch = useDispatch();
  const { contacts, status } = useSelector((state: any) => state.contactUs);

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [replyData, setReplyData] = useState({ title: "", message: "" });
  const [selectedContactId, setSelectedContactId] = useState<string | null>(
    null
  );

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      align: "center",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Name",
      accessorKey: "name",
      id: "name",
      align: "left",
      cell: (info: any) => (
        <strong>
          {info.getValue()} {info.row.original.last_name}
        </strong>
      ),
    },
    {
      header: "Mobile Number",
      accessorKey: "mobile_number",
      id: "mobile_number",
      align: "left",
      cell: (info: any) => (
        <span>{info.getValue() || "No status available"}</span>
      ),
    },
    {
      header: "Message",
      accessorKey: "message",
      id: "message",
      align: "left",
      cell: (info: any) => (
        <span>{info.getValue() || "No message available"}</span>
      ),
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original._id;
        return (
          <div>
            <IconButton onClick={() => handleOpenModal(id)}>
              <MdOutlineReplay />
            </IconButton>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getContactUs({ page: pageIndex, limit: pageSize }));
  }, [dispatch, pageIndex, pageSize]);

  useEffect(() => {
    if (status && contacts?.data) {
      setData(contacts.data);
      setTotalRows(contacts.pagination.total || 0);
    }
  }, [status, contacts]);

  const handleOpenModal = (id: string) => {
    setSelectedContactId(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setReplyData({ title: "", message: "" });
    setSelectedContactId(null);
  };

  const handleSendReply = () => {
    if (!replyData.message) {
      toast.error("Please enter a message");
      return;
    }

    if (selectedContactId) {
      dispatch(sendReply({ ...replyData, id: selectedContactId })).then(
        (resultAction) => {
          if (sendReply.rejected.match(resultAction)) {
            console.error(resultAction.payload || resultAction.error);
          } else {
            toast.success("Reply sent successfully");
            handleCloseModal();
          }
        }
      );
      handleCloseModal();
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              pb={1}
              pt={3}
              px={3}
            >
              <SoftTypography variant="h4" fontWeight="bold">
                Contact Inquiries
              </SoftTypography>
            </SoftBox>
            <SoftBox>
              <Table
                columns={columns}
                data={data}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalRows={totalRows}
                onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              />
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>

      {/* Modal for sending reply */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <SoftBox
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography
              style={{fontSize:'18px', fontWeight:'600'}}
            >
              Message
            </SoftTypography>
          </SoftBox>
          <SoftInput
            fullWidth
                name="Message"
            // label="Message"
            value={replyData.message}
            onChange={(e) =>
              setReplyData({ ...replyData, message: e.target.value })
            }
            margin="normal"
            multiline
            rows={4}
          />
          <SoftBox pt={2} display="flex" justifyContent="end" alignItems="center">
            <Button className="modal_btn " onClick={handleSendReply}>
              Send
            </Button>
            <Button
            className="modal_btn modal_cancel"
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
          </SoftBox>
        </SoftBox>
      </Modal>
    </DashboardLayout>
  );
};

export default ContactUs;
